Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var inspect_1 = require("../utilities/inspect");

var math_1 = require("../utilities/math");

function renderPath(ns, formatter) {
  if (formatter === void 0) {
    formatter = math_1.round;
  }

  if (inspect_1.isString(ns)) {
    return ns;
  }

  var result = [];

  for (var i = 0; i < ns.length; i++) {
    var n = ns[i];
    result.push(constants_1.MOVE_CURSOR, formatter(n[0]), formatter(n[1]), constants_1.DRAW_CURVE_CUBIC_BEZIER);
    var lastResult = void 0;

    for (var f = 2; f < n.length; f += 6) {
      var p0 = formatter(n[f]);
      var p1 = formatter(n[f + 1]);
      var p2 = formatter(n[f + 2]);
      var p3 = formatter(n[f + 3]);
      var dx = formatter(n[f + 4]);
      var dy = formatter(n[f + 5]);
      var isPoint = p0 == dx && p2 == dx && p1 == dy && p3 == dy;

      if (!isPoint || lastResult != (lastResult = '' + p0 + p1 + p2 + p3 + dx + dy)) {
        result.push(p0, p1, p2, p3, dx, dy);
      }
    }
  }

  return result.join(constants_1.SPACE);
}

exports.renderPath = renderPath;